module.exports = __webpack_public_path__ + "img/RedDown.52cc20a8.svg";